
import { useState } from 'react';
import Layout from '../../../components/layout/Layout';

export default function DepositoPage() {
  const [currentStep, setCurrentStep] = useState<'form' | 'confirmation' | 'success'>('form');
  const [formData, setFormData] = useState({
    tipoDeposito: '',
    valorDeposito: '',
    observacoes: ''
  });

  const [errors, setErrors] = useState<Record<string, string>>({});

  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    
    if (!formData.tipoDeposito) newErrors.tipoDeposito = 'Selecione o tipo de depósito';
    if (!formData.valorDeposito) newErrors.valorDeposito = 'Informe o valor do depósito';
    
    const valor = parseFloat(formData.valorDeposito.replace(/[^\d,]/g, '').replace(',', '.'));
    if (valor < 50) newErrors.valorDeposito = 'Valor mínimo: R$ 50,00';
    if (valor > 50000) newErrors.valorDeposito = 'Valor máximo: R$ 50.000,00';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (validateForm()) {
      setCurrentStep('confirmation');
    }
  };

  const handleConfirm = () => {
    // Simular processamento do depósito
    setTimeout(() => {
      setCurrentStep('success');
    }, 2000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    
    // Formatação para valor monetário
    if (name === 'valorDeposito') {
      const numericValue = value.replace(/\D/g, '');
      const formattedValue = (parseInt(numericValue) / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
      
      setFormData(prev => ({
        ...prev,
        [name]: numericValue ? formattedValue : ''
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
    
    // Limpar erro do campo quando o usuário começar a digitar
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleVoltar = () => {
    window.REACT_APP_NAVIGATE('/admin/incentivo/compra-pontos');
  };

  const handleNovoDeposito = () => {
    setFormData({
      tipoDeposito: '',
      valorDeposito: '',
      observacoes: ''
    });
    setErrors({});
    setCurrentStep('form');
  };

  const handleVoltarCompra = () => {
    window.REACT_APP_NAVIGATE('/admin/incentivo/compra-pontos');
  };

  // Dados bancários
  const dadosBancarios = {
    razaoSocial: 'Intelligence Bank Experian Soluções Digitais Ltda.',
    cnpj: '18.019.468/0001-93',
    banco: '237 (Bradesco)',
    agencia: '3263',
    conta: '0673456-1'
  };

  // Calcular valores
  const saldoAtual = 2450.00;
  const valorDepositoNumerico = parseFloat(formData.valorDeposito.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
  const novoSaldo = saldoAtual + valorDepositoNumerico;

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center space-x-2 mb-2">
              <button 
                onClick={handleVoltar}
                className="text-blue-600 hover:text-blue-800 cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-left-line"></i>
                </div>
              </button>
              <span className="text-sm text-gray-500">Financeiro</span>
              <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
              <span className="text-sm text-gray-900">
                {currentStep === 'form' && 'Depósito'}
                {currentStep === 'confirmation' && 'Confirmação do Depósito'}
                {currentStep === 'success' && 'Depósito Realizado'}
              </span>
            </div>
            <h1 className="text-2xl font-bold text-gray-900">
              {currentStep === 'form' && 'Realizar Depósito'}
              {currentStep === 'confirmation' && 'Confirmar Depósito'}
              {currentStep === 'success' && 'Depósito Realizado com Sucesso'}
            </h1>
            <p className="text-gray-600 mt-1">
              {currentStep === 'form' && 'Escolha a forma de depósito e informe o valor'}
              {currentStep === 'confirmation' && 'Revise os dados e confirme o depósito'}
              {currentStep === 'success' && 'Seu depósito foi processado com sucesso'}
            </p>
          </div>
        </div>

        {/* Progress Steps */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center font-semibold ${
                currentStep === 'form' ? 'bg-blue-600 text-white' : 'bg-green-500 text-white'
              }`}>
                {currentStep === 'form' ? '1' : <i className="ri-check-line"></i>}
              </div>
              <span className={`font-semibold ${currentStep === 'form' ? 'text-gray-900' : 'text-green-600'}`}>
                Dados do Depósito
              </span>
            </div>
            <div className={`flex-1 h-1 mx-4 ${currentStep === 'form' ? 'bg-gray-200' : 'bg-green-500'}`}></div>
            <div className="flex items-center space-x-2">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center font-semibold ${
                currentStep === 'confirmation' ? 'bg-blue-600 text-white' : 
                currentStep === 'success' ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-600'
              }`}>
                {currentStep === 'success' ? <i className="ri-check-line"></i> : '2'}
              </div>
              <span className={`font-semibold ${
                currentStep === 'confirmation' ? 'text-gray-900' : 
                currentStep === 'success' ? 'text-green-600' : 'text-gray-600'
              }`}>
                Confirmação
              </span>
            </div>
            <div className={`flex-1 h-1 mx-4 ${currentStep === 'success' ? 'bg-green-500' : 'bg-gray-200'}`}></div>
            <div className="flex items-center space-x-2">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center font-semibold ${
                currentStep === 'success' ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-600'
              }`}>
                {currentStep === 'success' ? <i className="ri-check-line"></i> : '3'}
              </div>
              <span className={`font-semibold ${currentStep === 'success' ? 'text-green-600' : 'text-gray-600'}`}>
                Finalizado
              </span>
            </div>
          </div>
        </div>

        {/* Formulário - Etapa 1 */}
        {currentStep === 'form' && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Formulário Principal */}
            <div className="lg:col-span-2">
              <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-6">Dados do Depósito</h3>
                
                <div className="space-y-6">
                  {/* Tipo de Depósito */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-3">
                      Tipo de Depósito *
                    </label>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Boleto Bancário */}
                      <div 
                        className={`border-2 rounded-lg p-4 cursor-pointer transition-all ${
                          formData.tipoDeposito === 'boleto' 
                            ? 'border-blue-500 bg-blue-50' 
                            : 'border-gray-200 hover:border-gray-300'
                        }`}
                        onClick={() => setFormData(prev => ({ ...prev, tipoDeposito: 'boleto' }))}
                      >
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                            <i className="ri-file-text-line text-blue-600"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900">Boleto Bancário</h4>
                            <p className="text-sm text-gray-600">Vencimento em 3 dias úteis</p>
                          </div>
                        </div>
                      </div>

                      {/* Transferência TED/PIX */}
                      <div 
                        className={`border-2 rounded-lg p-4 cursor-pointer transition-all ${
                          formData.tipoDeposito === 'transferencia' 
                            ? 'border-blue-500 bg-blue-50' 
                            : 'border-gray-200 hover:border-gray-300'
                        }`}
                        onClick={() => setFormData(prev => ({ ...prev, tipoDeposito: 'transferencia' }))}
                      >
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                            <i className="ri-bank-line text-green-600"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900">Transferência TED/PIX</h4>
                            <p className="text-sm text-gray-600">Crédito imediato</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {errors.tipoDeposito && <p className="text-red-500 text-xs mt-1">{errors.tipoDeposito}</p>}
                  </div>

                  {/* Valor do Depósito */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Valor do Depósito *
                    </label>
                    <input
                      type="text"
                      name="valorDeposito"
                      value={formData.valorDeposito}
                      onChange={handleChange}
                      className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-lg font-semibold ${
                        errors.valorDeposito ? 'border-red-300' : 'border-gray-300'
                      }`}
                      placeholder="R$ 0,00"
                    />
                    <div className="flex justify-between text-xs text-gray-500 mt-1">
                      <span>Valor mínimo: R$ 50,00</span>
                      <span>Valor máximo: R$ 50.000,00</span>
                    </div>
                    {errors.valorDeposito && <p className="text-red-500 text-xs mt-1">{errors.valorDeposito}</p>}
                  </div>

                  {/* Observações */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Observações
                    </label>
                    <textarea
                      name="observacoes"
                      value={formData.observacoes}
                      onChange={handleChange}
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm resize-none"
                      placeholder="Observações adicionais sobre o depósito..."
                    ></textarea>
                    <div className="text-xs text-gray-500 mt-1">
                      {formData.observacoes.length}/500 caracteres
                    </div>
                  </div>
                </div>

                {/* Dados Bancários - Mostrar apenas se transferência for selecionada */}
                {formData.tipoDeposito === 'transferencia' && (
                  <div className="mt-8 p-6 bg-green-50 border border-green-200 rounded-lg">
                    <h4 className="text-lg font-semibold text-green-900 mb-4 flex items-center space-x-2">
                      <i className="ri-bank-line"></i>
                      <span>Dados Bancários para Transferência</span>
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                      <div>
                        <span className="text-green-700 font-medium">Razão Social:</span>
                        <p className="text-green-900 font-semibold">{dadosBancarios.razaoSocial}</p>
                      </div>
                      <div>
                        <span className="text-green-700 font-medium">CNPJ:</span>
                        <p className="text-green-900 font-semibold">{dadosBancarios.cnpj}</p>
                      </div>
                      <div>
                        <span className="text-green-700 font-medium">Banco:</span>
                        <p className="text-green-900 font-semibold">{dadosBancarios.banco}</p>
                      </div>
                      <div>
                        <span className="text-green-700 font-medium">Agência:</span>
                        <p className="text-green-900 font-semibold">{dadosBancarios.agencia}</p>
                      </div>
                      <div className="md:col-span-2">
                        <span className="text-green-700 font-medium">Conta:</span>
                        <p className="text-green-900 font-semibold">{dadosBancarios.conta}</p>
                      </div>
                    </div>
                    <div className="mt-4 p-3 bg-green-100 rounded-lg">
                      <p className="text-xs text-green-800">
                        <strong>Importante:</strong> Após realizar a transferência, envie o comprovante para nosso e-mail financeiro@empresa.com para agilizar a confirmação do depósito.
                      </p>
                    </div>
                  </div>
                )}

                {/* Botões de Ação */}
                <div className="flex items-center justify-between mt-8 pt-6 border-t border-gray-200">
                  <button 
                    type="button"
                    onClick={handleVoltar}
                    className="px-6 py-2 text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Voltar
                  </button>
                  <button 
                    type="submit"
                    className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Continuar
                  </button>
                </div>
              </form>
            </div>

            {/* Sidebar com Resumo */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sticky top-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Resumo do Depósito</h3>
                
                <div className="space-y-4">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Saldo Atual:</span>
                    <span className="text-sm font-medium text-gray-900">
                      R$ {saldoAtual.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600">Valor do Depósito:</span>
                    <span className="text-sm font-medium text-blue-600">
                      {formData.valorDeposito || 'R$ 0,00'}
                    </span>
                  </div>
                  <div className="border-t border-gray-200 pt-4">
                    <div className="flex justify-between">
                      <span className="text-base font-semibold text-gray-900">Novo Saldo:</span>
                      <span className="text-base font-bold text-green-600">
                        R$ {novoSaldo.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Informações Importantes */}
                <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                  <h4 className="text-sm font-semibold text-blue-900 mb-2">Informações Importantes</h4>
                  <ul className="text-xs text-blue-800 space-y-1">
                    <li>• Boleto: Crédito em até 2 dias úteis</li>
                    <li>• TED/PIX: Crédito imediato após confirmação</li>
                    <li>• Valor mínimo: R$ 50,00</li>
                    <li>• Valor máximo: R$ 50.000,00</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Confirmação - Etapa 2 */}
        {currentStep === 'confirmation' && (
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
              <div className="text-center mb-8">
                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-alert-line text-yellow-600 text-2xl"></i>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Confirmar Depósito</h3>
                <p className="text-gray-600">Revise os dados do depósito antes de confirmar</p>
              </div>

              {/* Detalhes do Depósito */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Dados do Depósito</h4>
                  <div className="space-y-3">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Tipo:</span>
                      <span className="font-medium text-gray-900">
                        {formData.tipoDeposito === 'boleto' ? 'Boleto Bancário' : 'Transferência TED/PIX'}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Valor:</span>
                      <span className="font-medium text-gray-900">{formData.valorDeposito}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Data/Hora:</span>
                      <span className="font-medium text-gray-900">{new Date().toLocaleString('pt-BR')}</span>
                    </div>
                  </div>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Resumo Financeiro</h4>
                  <div className="space-y-3">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Saldo Atual:</span>
                      <span className="font-medium text-gray-900">
                        R$ {saldoAtual.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Valor do Depósito:</span>
                      <span className="font-medium text-blue-600">{formData.valorDeposito}</span>
                    </div>
                    <div className="flex justify-between border-t border-gray-200 pt-3">
                      <span className="text-base font-semibold text-gray-900">Novo Saldo:</span>
                      <span className="text-base font-bold text-green-600">
                        R$ {novoSaldo.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Dados Bancários - Se transferência */}
              {formData.tipoDeposito === 'transferencia' && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
                  <h4 className="text-lg font-semibold text-green-900 mb-4">Dados Bancários para Transferência</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                    <div>
                      <span className="text-green-700 font-medium">Razão Social:</span>
                      <p className="text-green-900 font-semibold">{dadosBancarios.razaoSocial}</p>
                    </div>
                    <div>
                      <span className="text-green-700 font-medium">CNPJ:</span>
                      <p className="text-green-900 font-semibold">{dadosBancarios.cnpj}</p>
                    </div>
                    <div>
                      <span className="text-green-700 font-medium">Banco:</span>
                      <p className="text-green-900 font-semibold">{dadosBancarios.banco}</p>
                    </div>
                    <div>
                      <span className="text-green-700 font-medium">Agência:</span>
                      <p className="text-green-900 font-semibold">{dadosBancarios.agencia}</p>
                    </div>
                    <div className="md:col-span-2">
                      <span className="text-green-700 font-medium">Conta:</span>
                      <p className="text-green-900 font-semibold">{dadosBancarios.conta}</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Observações */}
              {formData.observacoes && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8">
                  <h4 className="text-sm font-semibold text-blue-900 mb-2">Observações</h4>
                  <p className="text-sm text-blue-800">{formData.observacoes}</p>
                </div>
              )}

              {/* Termos e Condições */}
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-8">
                <div className="flex items-start space-x-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className="ri-information-line text-yellow-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-yellow-900 mb-2">Termos do Depósito</h4>
                    <ul className="text-sm text-yellow-800 space-y-1">
                      <li>• Boleto bancário: Crédito em até 2 dias úteis após o pagamento</li>
                      <li>• Transferência TED/PIX: Crédito imediato após confirmação bancária</li>
                      <li>• O valor será creditado automaticamente na sua conta digital</li>
                      <li>• Em caso de dúvidas, entre em contato com o suporte financeiro</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Botões de Ação */}
              <div className="flex items-center justify-between">
                <button 
                  onClick={() => setCurrentStep('form')}
                  className="px-6 py-2 text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-left-line"></i>
                  </div>
                  <span>Voltar e Editar</span>
                </button>
                <button 
                  onClick={handleConfirm}
                  className="px-8 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2 text-lg font-semibold"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-check-line"></i>
                  </div>
                  <span>Confirmar Depósito</span>
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Sucesso - Etapa 3 */}
        {currentStep === 'success' && (
          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-check-line text-green-600 text-4xl"></i>
                </div>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Depósito Realizado com Sucesso!</h3>
              <p className="text-gray-600 mb-8">
                {formData.tipoDeposito === 'boleto' 
                  ? 'Seu boleto foi gerado e será enviado por e-mail. O crédito será realizado após o pagamento.'
                  : 'Utilize os dados bancários fornecidos para realizar a transferência. O crédito será imediato após a confirmação.'
                }
              </p>

              {/* Detalhes da Operação */}
              <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                  <div className="flex justify-between">
                    <span className="text-green-700">Protocolo:</span>
                    <span className="font-bold text-green-900">#{Math.random().toString(36).substr(2, 9).toUpperCase()}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-green-700">Data/Hora:</span>
                    <span className="font-bold text-green-900">{new Date().toLocaleString('pt-BR')}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-green-700">Tipo:</span>
                    <span className="font-bold text-green-900">
                      {formData.tipoDeposito === 'boleto' ? 'Boleto Bancário' : 'Transferência TED/PIX'}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-green-700">Valor:</span>
                    <span className="font-bold text-green-900">{formData.valorDeposito}</span>
                  </div>
                </div>
              </div>

              {/* Ações específicas por tipo */}
              {formData.tipoDeposito === 'boleto' && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
                  <h4 className="text-lg font-semibold text-blue-900 mb-4">Próximos Passos</h4>
                  <div className="flex items-center justify-center space-x-4 mb-4">
                    <button className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2">
                      <i className="ri-download-line"></i>
                      <span>Baixar Boleto</span>
                    </button>
                    <button className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2">
                      <i className="ri-mail-line"></i>
                      <span>Enviar por E-mail</span>
                    </button>
                  </div>
                  <p className="text-sm text-blue-800">
                    Vencimento: {new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toLocaleDateString('pt-BR')}
                  </p>
                </div>
              )}

              {/* Próximos Passos */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8 text-left">
                <h4 className="text-sm font-semibold text-blue-900 mb-3">Próximos Passos</h4>
                <div className="space-y-2">
                  {formData.tipoDeposito === 'boleto' ? (
                    <>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs font-bold">1</div>
                        <span className="text-sm text-blue-800">Realize o pagamento do boleto até o vencimento</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs font-bold">2</div>
                        <span className="text-sm text-blue-800">Aguarde a confirmação bancária (até 2 dias úteis)</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs font-bold">3</div>
                        <span className="text-sm text-blue-800">O valor será creditado automaticamente</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs font-bold">1</div>
                        <span className="text-sm text-blue-800">Realize a transferência TED/PIX com os dados fornecidos</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs font-bold">2</div>
                        <span className="text-sm text-blue-800">Envie o comprovante para financeiro@empresa.com</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center text-xs font-bold">3</div>
                        <span className="text-sm text-blue-800">O crédito será realizado imediatamente após confirmação</span>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Botões de Ação */}
              <div className="flex items-center justify-center space-x-4">
                <button 
                  onClick={handleVoltarCompra}
                  className="px-6 py-2 text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                >
                  Voltar à Compra
                </button>
                <button 
                  onClick={handleNovoDeposito}
                  className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                >
                  Novo Depósito
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
